<template>

		<h6 class="margin-t-40 margin-b-24">Bedrijfsgegevens</h6>

		<c-input
			:label="'Bedrijf'"
			:horizontal="true"
			type="text"
			name="name"
			v-model="name"
			 />

		<c-input
			@change="uploadFile"
			:label="'Afbeelding'"
			:horizontal="true"
			type="file"
			accept="image/*"
			name="image"
			v-model="image"
			ref="file"/>
			
			<template v-if="client_type_id == $constants.client.EINDKLANT">
				<c-input
				:label="'Factuuromschrijving Reuzado'"
				:horizontal="true"
				type="text"
				v-model="invoice_description"
				name="invoice_description"/>

				<c-input
				:label="'Factuurreferentie klant'"
				:horizontal="true"
				type="text"
				v-model="invoice_reference"
				name="invoice_reference"/>
			</template>

		<c-zipcode-address v-if="edit && client.visiting_address"
			:label="'Postcode en hnr.'"
			:sublabel="'Bezoekadres'"
			:horizontal="true"
			ref="zipcode"
			:zipcode="client.visiting_address.zipcode"
			:number="client.visiting_address.number"
			:street="client.visiting_address.street"
			:city="client.visiting_address.city"
			name="visiting_address"
		/>

		<div v-if="!edit">

			<CSubForm name="addresses">
				<c-zipcode-address
					:label="'Postcode en hnr.'"
					:sublabel="'Bezoekadres'"
					:horizontal="true"
					ref="zipcode"
					:name="0"
				/>
			</CSubForm>

			<c-checkbox
				id="delivery-address"
				v-model="deliveryAddress"
				:horizontal="true"
				:required="false"
				:label="' '"
				:name="'name'"
				:labeltext="'name'"
				:options="[
					{name:'Bezoekadres wijkt af van afleveradres', id:'1'},
				]">
			</c-checkbox>

			<!-- Wanneer checkbox "Bezoekadres wijkt af van afleveradres" true is: -->
			<div v-if="deliveryAddress">
				<CSubForm name="addresses" v-for="count in deliveryAddressCount" :key="count">
					<c-zipcode-address
						:label="'Postcode en hnr.'"
						:sublabel="'Afleveradres'"
						:horizontal="true"
						ref="extra_address"
						:name="count"
						@delete-delivery-address="deleteDeliveryAddress">
					</c-zipcode-address>
				</CSubForm>
				<a @click="AddDeliveryAddress" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
					<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
					<span>Nog een afleveradres toevoegen</span>
				</a>
			</div>
		</div>
		<CSubForm v-if="!edit" name="contacts">
            <CSubForm  v-for="(contact,index) in contacts" :key="index" :name="index">
                <c-personal-data
                    :ref="'personalform'"
                    :edit="edit"
                    @delete-user="removeUser(index)"
                    :contact="contact">
                </c-personal-data>
            </CSubForm>

		</CSubForm>

		<div v-if="!edit">
			<a @click="AddUser" class="c-text-icon td-none color-primary font-heading margin-b-16 h-form-horizontal-margin">
				<svg class="margin-r-8" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"/></svg>
				<span>Nog een gebruiker toevoegen</span>
			</a>
		</div>
</template>

<script>
import Form from '@mixins/Form';
import CZipcodeAddress from '@components/ZipcodeAddress';
import CPersonalData from '@components/PersonalData';
import Helpers from "../support/Helpers";

export default {
	mixins: [Form],
	components: {
    CZipcodeAddress,
    CPersonalData
	},
	props: {
        edit: {
            required: false,
			default: false
        },
		client: {
			required: false
		},
		client_type_id: {
			required: true
		}
    },
	data() {
		return {
			deliveryAddress: false,
			deliveryAddressCount: 1,
			zipcodeDeliver: '',
			housenumberDeliver: '',
			zipcode: '',
            contacts: [],
			number: '',
			addition: '',
			street: '',
			city: '',
			userCount: 1,
			name: '',
			image: null,
			postnl_delivery: 0,
			invoice_description: '',
			invoice_reference: ''
		};
	},
	methods: {
		uploadFile(event) {
        	 let files = Array.from(event.target.files);
			 this.image = files[0];
      	},
		getData() {

			let submitData = {
				name: this.name,
				image: this.image,
				invoice_description: this.invoice_description,
				invoice_reference: this.invoice_reference,
				postnl_delivery: this.postnl_delivery
			};

			let persondata = {
				contacts: []
			};

            if (this.$refs.personalform) {
                this.$refs.personalform.forEach( (component, index) => {
                    persondata['contacts'][index] = component.getData();
                });
            }

			let data = {};

			Object.assign(data, submitData, persondata);

			let addressData = {
				addresses: []
			};

			addressData['addresses'][0] = this.$refs.zipcode.getData();

			if(this.deliveryAddress && this.deliveryAddressCount > 0){
				this.$refs.extra_address.forEach( (component, index) => {
					addressData['addresses'][index] = component.getData();
				});
			}

			Object.assign(data, addressData);

			return data;
		},
		clear(){
			this.deliveryAddress = false;
			this.deliveryAddressCount = 1;
			this.zipcodeDeliver = '';
			this.housenumberDeliver = '';
			this.zipcode = '';
			this.number = '';
			this.addition = '';
			this.street = '';
			this.city = '';
			this.userCount = 1;
			this.name = '';
			this.image = null;
			this.postnl_delivery = 0;
			this.$refs.zipcode.clear();
		},
		AddDeliveryAddress() {
			this.deliveryAddressCount++;
		},
		deleteDeliveryAddress() {
			this.deliveryAddressCount--;
		},
		AddUser() {
			this.contacts.push({
                id: Helpers.uid(),
                first_name: '',
                last_name: '',
                title: '',
                phone: '',
                email: '',
                has_account: false,
            })
		},
		removeUser(index) {
			this.contacts.splice(index, 1);
		},
	},
	mounted() {
		if(this.edit){
			this.name = this.client.name;
            this.contacts = this.client.contacts ?? [];
			this.invoice_description = this.client.invoice_description;
			this.invoice_reference = this.client.invoice_reference;
		}
	}
}
</script>
